import { SECTION_TEMPLATE_ID } from './action';
const initialState = {
    sectionTemplateSearchData: null
}

const sectionTemplateSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case SECTION_TEMPLATE_ID:
            return state = {
                ...state,
                sectionTemplateSearchData: action.data
            }
        default:
            return state
    }
}
export default sectionTemplateSearchReducer;
